import React from 'react';
import Icon from '../../../components/AppIcon';

const BenefitsSection = () => {
  const benefits = [
    {
      icon: 'UserX',
      title: 'Complete Anonymity',
      description: 'Create profiles without revealing your real identity. Use display names and control what you share.',
      color: 'primary'
    },
    {
      icon: 'MessageCircleOff',
      title: 'Secure Messaging',
      description: 'End-to-end encrypted conversations with disappearing messages and screenshot protection.',
      color: 'secondary'
    },
    {
      icon: 'Eye',
      title: 'Privacy Controls',
      description: 'Blur photos, hide your face, and control who can message you with advanced privacy settings.',
      color: 'accent'
    },
    {
      icon: 'Shield',
      title: 'Data Protection',
      description: 'Your personal information is encrypted and never shared with third parties or social networks.',
      color: 'success'
    },
    {
      icon: 'Search',
      title: 'Smart Discovery',
      description: 'Find compatible matches based on interests, location, and preferences with advanced filters.',
      color: 'warning'
    },
    {
      icon: 'Heart',
      title: 'Judgment-Free Zone',
      description: 'Connect with like-minded individuals in a safe space designed for discreet relationships.',
      color: 'primary'
    }
  ];

  const getColorClasses = (color) => {
    const colorMap = {
      primary: 'bg-primary/10 text-primary',
      secondary: 'bg-secondary/10 text-secondary',
      accent: 'bg-accent/10 text-accent',
      success: 'bg-success/10 text-success',
      warning: 'bg-warning/10 text-warning'
    };
    return colorMap?.[color] || colorMap?.primary;
  };

  return (
    <section className="py-12 md:py-16 lg:py-20 bg-muted/30">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-8 md:mb-12 lg:mb-16">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground mb-3 md:mb-4">
            Why Choose Bamchik?
          </h2>
          <p className="text-base md:text-lg text-muted-foreground max-w-2xl mx-auto">
            Experience the most secure and private platform for discreet connections
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 lg:gap-8">
          {benefits?.map((benefit, index) => (
            <div
              key={index}
              className="bg-card rounded-xl p-6 md:p-8 shadow-warm hover:shadow-warm-lg transition-smooth group"
            >
              <div className={`w-12 h-12 md:w-14 md:h-14 lg:w-16 lg:h-16 rounded-lg ${getColorClasses(benefit?.color)} flex items-center justify-center mb-4 md:mb-5 group-hover:scale-110 transition-smooth`}>
                <Icon name={benefit?.icon} size={24} className="md:w-7 md:h-7 lg:w-8 lg:h-8" />
              </div>
              <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground mb-2 md:mb-3">
                {benefit?.title}
              </h3>
              <p className="text-sm md:text-base text-muted-foreground leading-relaxed">
                {benefit?.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;